module.exports = __webpack_public_path__ + "static/media/molpoints.b0f2bfe2.png";